module.exports = __webpack_public_path__ + "img/message-square.42f61b6c.svg";